import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { nextTick, ref } from "vue";
import AppResizableDropdown from "@/components/ui-kit/dropdown/AppResizableDropdown.vue";
import { useModalEscape } from "@/composables/useModalEscape";


export default /*@__PURE__*/_defineComponent({
  __name: 'JobResizeModal',
  setup(__props, { expose: __expose }) {

const $modal = ref<InstanceType<typeof AppResizableDropdown> | null>(null);
const $content = ref<HTMLElement | null>(null);
const isOpen = ref(false);

const { activate: activateEsc, deactivate: deactivateEsc } = useModalEscape({
  content: $content,
  close: () => $modal.value?.close(),
});

const handleClose = () => {
  isOpen.value = false;
  deactivateEsc();
};

const close = () => {
  $modal.value?.close();
};

const onOpen = async () => {
  isOpen.value = true;
  await nextTick();
  await $modal.value?.open();
  activateEsc();
};

__expose({ onOpen, close });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _renderSlot(_ctx.$slots, "default", {
      isExpanded: false,
      close: close
    }),
    _createVNode(AppResizableDropdown, {
      ref_key: "$modal",
      ref: $modal,
      name: "job-resize-modal",
      class: "job-resize-modal-anchor",
      resizable: "",
      centered: "",
      "fit-content-height": "",
      "fullscreen-on-mobile": "",
      "initial-width": 900,
      "max-width": 900,
      "min-width": 320,
      "min-height": 120,
      "max-height": 900,
      "close-by-click-outside": true,
      "ignore-click-outside": ".dropdown-content, .q-dialog",
      "close-by-esc": false,
      "hide-by-parent-scroll": false,
      onClose: handleClose
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          ref_key: "$content",
          ref: $content,
          class: "job-resize-modal"
        }, [
          (isOpen.value)
            ? _renderSlot(_ctx.$slots, "default", {
                key: 0,
                isExpanded: true,
                close: close
              })
            : _createCommentVNode("", true)
        ], 512)
      ]),
      _: 3
    }, 512)
  ], 64))
}
}

})